var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide-left","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }